import { Component, EventEmitter, Output, Input } from '@angular/core';
import { openConfirmDeleteGetResult } from '../dialog.confirmDelete.component';
import {MatDialog } from '@angular/material/dialog';
import { IconComponent } from '../icon/icon.component';

// it might seem like overkill to have this as a component, but the styling to get it right took me way too long to figure out the first time
@Component({
    selector: 'delete-button',
    template: `
<icon icon="delete18" (click)="openDeleteDialog($event)"></icon>
`,
    styles: [`
  icon { width: 18px; opacity: 0.6; cursor: pointer; margin-right:7px; }
`],
    standalone: true,
    imports: [IconComponent],
})

export class DeleteButtonComponent {
  @Output() delete: EventEmitter<void> = new EventEmitter();
  @Input() deleteText: string = ''
  @Input() deleteTitle: string = ''
  @Input() deleteButtonText = 'DELETE'
  constructor(private dialog: MatDialog) { }

  async openDeleteDialog(event) {
    event.stopPropagation()
    const data = {
      title: this.deleteTitle,
      rect: event.target.getBoundingClientRect(),
      para: this.deleteText,
      deleteButtonText: this.deleteButtonText,
      dialog: this.dialog
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return
    this.delete.emit()
  }

}

